const tableHeader = ['Vendedor', 'Comissão', 'Contato', 'Gerenciar', 'Editar', 'Excluir'];

const Tablecadastro = [
  {
    id: 'nome',
    title: 'Nome',
    type: 'text',
    placeholder: 'Informe o nome do vendedor ...',
  },
  {
    id: 'endereco',
    title: 'Endereço',
    type: 'text',
    placeholder: 'Informe o endereço  ...',
  },
  {
    id: 'telefone',
    title: 'Telefone/Whats',
    type: 'text',
    placeholder: 'informe o whatsApp ...',
  },
  {
    id: 'emailContato',
    title: 'Email Contato',
    type: 'email',
    placeholder: 'Informe a Email de contato ...',
  },
  {
    id: 'documento',
    title: 'Documento',
    type: 'text',
    placeholder: 'validar...',
  },
  {
    id: 'tipoDocumentoo',
    title: 'Tipo Documento',
    type: 'text',
    placeholder: 'validar ...',
  },
  {
    id: 'contato',
    title: 'Contato/Tel',
    type: 'text',
    placeholder: 'Informe o telefone para contato ...',
  },
  {
    id: 'comissao',
    title: 'Comissão',
    type: 'number',
    placeholder: 'Informe a comissão ...',
  },
  {
    id: 'emailVendedor',
    title: 'Email login',
    type: 'email',
    placeholder: 'Informe o email do vendedor ...',
  },
  {
    id: 'passwordVendedor',
    title: 'Senha',
    type: 'password',
    placeholder: 'Informe o senha do vendedor ...',
  },
  {
    id: 'permissaoVendedor',
    title: 'Permissão',
    type: 'select',
    placeholder: 'Selecione uma permissão ...',
  },
];

const title = 'Cadastro de Vendedor';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'vendedores',
};
